import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate('/admin');
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      const detail = err.response?.data?.detail;
      const msg = typeof detail === 'string' ? detail : Array.isArray(detail) ? detail.map(e => e.msg || '').join(' ') : 'Login failed';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FCFBF9] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <h1 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl font-medium text-[#1C1917] mb-2">
            Heirloom Stories
          </h1>
          <p className="text-sm text-[#78716C]">Admin Dashboard</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6" data-testid="admin-login-form">
          <div>
            <label className="block text-xs uppercase tracking-widest font-semibold text-[#78716C] mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full bg-transparent border border-[#D6D3CD] focus:border-[#1C1917] px-4 py-3 text-[#1C1917] outline-none transition-colors text-sm"
              required
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest font-semibold text-[#78716C] mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full bg-transparent border border-[#D6D3CD] focus:border-[#1C1917] px-4 py-3 text-[#1C1917] outline-none transition-colors text-sm"
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-button"
            className="w-full bg-[#1C1917] text-[#FCFBF9] hover:bg-[#322f2d] disabled:opacity-50 py-3.5 text-sm font-medium tracking-wide transition-all duration-300 flex items-center justify-center gap-2"
          >
            {loading ? <><Loader2 size={16} className="animate-spin" /> Signing in...</> : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
